// extracted by mini-css-extract-plugin
module.exports = {"areainfoWrapper":"areaChart_areainfoWrapper__2oODP","areaInfoLeft":"areaChart_areaInfoLeft__1MoZV","areainfoItem":"areaChart_areainfoItem__23k_q"};